<template>
	<q-dialog v-model="isVisible" persistent backdrop-filter="blur(4px)" :maximized="$q.screen.lt.sm">
		<q-card
			:class="{ 'tw-px-10 md:tw-px-28 tw-py-10 tw-flex tw-flex-col tw-gap-8 tw-min-w-[50vw]': !$q.screen.lt.sm, 'tw-px-10 md:tw-px-28 tw-py-10 tw-flex tw-flex-col tw-gap-8 tw-min-w-[50vw] tw-h-full tw-justify-between': $q.screen.lt.sm }">

			<div class="tw-flex tw-items-center tw-justify-between">
				<p class="tw-text-2xl tw-text-[#f35610] tw-font-SemiExpandedExtraBold">
					VERIFICATION
				</p>
				<q-btn flat round dense icon="close" v-close-popup />
			</div>

			<div class="tw-items-center tw-text-center">
				<div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-mb-2">
					<ErrorSvg class="tw-w-10 tw-h-10" />
					<h3
						class="tw-text-[20px] md:tw-text-[28px] lg:tw-text-[28px] tw-font-ExpandedBold tw-text-[rgba(243,86,16,1)] tw-my-2">
						Varification Failed
					</h3>
				</div>
				<p class="tw-font-ExpandedRegular tw-text-[#666666] tw-text-xl tw-my-3">
					{{ errorMessage }}
				</p>
				<p class="tw-font-ExpandedRegular tw-text-[#666666] tw-text-[18px] tw-leading-6">
					Please request a new verification link to continue.
				</p>
			</div>

			<div class="">
				<q-btn label="REQUEST NEW LINK" type="submit"
					class="full-width tw-rounded-xl tw-text-white tw-text-xl tw-font-SemiExpandedExtraBold"
					@click="requestNewLink" style="background-color: #f35610; font-style: italic" />
			</div>
		</q-card>
	</q-dialog>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { useLoginDialog } from '../composables/useLoginDialog.js'
import ErrorSvg from './svg/ErrorSvg.vue'

const props = defineProps({
	modelValue: {
		type: Boolean,
		default: false
	},
	errorType: {
		type: String,
		default: 'invalid_token'
	}
})

const emit = defineEmits(['update:modelValue', 'closed', 'request-new-link'])

const { showDialog } = useLoginDialog()
const isVisible = ref(props.modelValue)

// Watch for prop changes
watch(() => props.modelValue, (newVal) => {
	isVisible.value = newVal
})

// Watch for dialog visibility changes
watch(isVisible, (newVal) => {
	emit('update:modelValue', newVal)
})

// Compute error message based on error type
const errorMessage = computed(() => {
	switch (props.errorType) {
		case 'invalid_token':
			return 'The verification link is invalid or has expired.'
		case 'expired_token':
			return 'The verification link has expired.'
		case 'already_verified':
			return 'This email has already been verified.'
		default:
			return 'There was an error with your verification link.'
	}
})

const closeDialog = () => {
	isVisible.value = false
	emit('closed')
}

const requestNewLink = () => {
	isVisible.value = false
	emit('request-new-link')
	// Show the login dialog to request a new link
	showDialog()
}
</script>